import Request from '../utilis/request';

export function getWebsites(params) {
    return Request({
        url:'/api/websites',
        method:'get',
        params: params
    })
}
export function getEditableHash(data) {
    return Request({
        url: '/website/hash',
        method: 'post',
        data: data
    })
}
export function getAddresses(website_id){
    return Request({
        url: '/api/websites/addresses',
        method: 'get',
        params: {'id': website_id}
    })
}
export function getAdminWebsites(params = null) {
    return Request({
        url:'/api/admin/websites',
        method:'get',
        params: params
    })
}
export function getWebsiteProducts(params, id) {
    return Request({
        url:'/api/websites/'+id+'/products',
        method:'get',
        params: params
    })
}
export function updateWebsiteProducts(id, data) {
    return Request({
        url:'/api/websites/'+id+'/products',
        method:'post',
        data: data,
    })
}
export function refreshWebsite(id) {
    return Request({
        url:'/api/websites/'+id+'/refresh',
        method:'post',
    })
}
/* PAYMENTS */
export function getOnboardLink(second_paypal_account,params) {
    return Request({
        url: '/api/paypal/generate_onboard_link?second_paypal_account='+second_paypal_account,
        method: 'get',
        params: params
    })
}
export function getPayments(website_id, params) {
    return Request({
        url: '/api/websites/'+website_id,
        method: 'get',
        params: params
    })
}
export function getSecondPayPalAccount () {
    return Request({
        url: '/api/websites/second_payment',
        method: 'get'
    })
}
export function deleteSecondPayPalAccount(){
    return Request({
        url: '/api/websites/second_payment',
        method: 'post'
    })
}
export function savePayments(website_id, data) {
    return Request({
        url: '/api/websites/'+website_id+'/payments',
        method: 'post',
        data: data,
    })
}
export function saveEmails(data) {
    return Request({
        url: '/api/websites/emails',
        method: 'post',
        data: data
    })
}
export function getAvailablePatterns() {
    return Request({
        url: '/api/partials',
        method: 'get',
    })
}
export function cloneWebsite(data) {
    return Request({
        url: '/api/websites/clone',
        method: 'post',
        data: data
    })
}
export function deleteWebsites(data) {
    return Request({
        url: '/api/websites/destroy',
        method: 'post',
        data: data
    })
}
export function getExampleWebsites(params) {
    return Request({
        url: '/api/websites/examples',
        method: 'get',
        params: params
    })
}
export function braintreeMerchant(data){
    return Request({
        url: '/api/websites/braintree_merchant',
        method: 'post',
        data: data
    })
}
export function validateDomain(data) {
    return Request({
        url: '/api/validate_domain',
        method: 'post',
        data: data
    })
}
export function getAllAttachmentTypes() {
    return Request({
        url: '/api/get/attachments',
        method: 'get'
    })
}
export function transferWebsite(data) {
    return Request({
        url: '/api/transfer/website',
        method: 'post',
        data: data
    })
}
export function copyPayPalData(id){
    return Request({
        url: '/api/copy/paypal/'+id,
        method: 'post'
    })
}
export function copyPayPalDataFromWebsite(id){
    return Request({
        url: '/api/copy/paypal/website/'+id,
        method: 'post'
    })
}
export function sendLink(data){
    return Request({
        url: '/api/send/paypal/link',
        method: 'post',
        data: data
    })
}
export function getInvitations(){
    return Request({
        url: '/api/get/invitations',
        method: 'get'
    })
}
export function deleteInvitation(data){
    return Request({
        url: '/api/delete/invitation',
        method: 'post',
        data: data
    })
}
export function sendInvitation(data){
    return Request({
        url: '/api/send/invitation',
        method: 'post',
        data: data
    })
}
export function createCode(data){
    return Request({
        url: '/api/create/invitation/code',
        method: 'post',
        data: data
    })
}
export function deleteWholeInvitation(data){
    return Request({
        url: '/api/delete/whole/invitation',
        method: 'post',
        data: data
    })
}
export function acceptInvitation(data){
    return Request({
        url: '/api/accept/invitation',
        method: 'post',
        data: data
    })
}
export function declineInvitation(data){
    return Request({
        url: '/api/decline/invitation',
        method: 'post',
        data: data
    })
}
export function storePermission(data){
    return Request({
        url: '/api/store/permission',
        method: 'post',
        data: data
    })
}
export function updatePermission(data){
    return Request({
        url: '/api/update/permission',
        method: 'post',
        data: data
    })
}
export function deletePermission(data){
    return Request({
        url: '/api/delete/permission',
        method: 'post',
        data: data
    })
}
export function getStripeOnboardLink(params){
    return Request({
        url: '/api/stripe/generate_onboard',
        method: 'get',
        params: params
    })
}
export function resetStripeId(){
    return Request({
        url: '/api/websites/stripe_id',
        method: 'post'
    })
}
export function refreshStripe(data){
    return Request({
        url: '/api/refresh/stripe',
        method: 'post',
        data: data
    })
}
export function getAffiliations(params){
    return Request({
        url: '/api/affiliations',
        method: 'get',
        params: params
    })
}

